interface CltStepHeaderProps {
  title: string
  description?: string
}

export function CltStepHeader({ title, description }: CltStepHeaderProps) {
  return (
    <div className="mb-6">
      <h2 className="text-xl font-bold text-foreground">{title}</h2>
      {description && (
        <p className="mt-1 text-sm text-muted-foreground">{description}</p>
      )}
    </div>
  )
}
